import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { FuseValidators } from '@fuse/validators';
import { AuthService } from 'app/core/auth/auth.service';
import { finalize, Subscription, take, timer } from 'rxjs';
import { HelperService } from '../../../core/services/helper/helper.service';
import { CommonConstants } from '../../../core/constants/common-constants';
import { transform } from 'lodash';
import { JsonPipe, NgClass } from '@angular/common';
import { LABELS } from '../../../core/constants/label-constants';
import { MatListItemAvatar } from '@angular/material/list';
import { environment } from 'environments/environment.prod';

@Component({
    selector: 'auth-reset-password',
    templateUrl: './reset-password.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        RouterLink,
        NgClass,
    ],
})
export class AuthResetPasswordComponent implements OnInit {
    @ViewChild('resetPasswordNgForm') resetPasswordNgForm: NgForm;
    isSendOtp: boolean = false;
    email: string;
    token: string;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    resetPasswordForm: UntypedFormGroup;
    showAlert: boolean = false;
    hideResendBtn: boolean = true;
    displayTimer: boolean = false;
    display: any;
    countDown!: Subscription;
    resendOtp: boolean = false;
    seconds: any;
    isPartner: boolean = false;
    isSetPassword: boolean = false;
    emailFromSession: any;
    emailFromUrl: any;

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder,
        private _helper: HelperService,
        public _router: Router,
        public _route: ActivatedRoute,
    ) {
        this.isPartner = this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1; 
    
    }

    ngOnDestroy(): void {
        this._helper.removeLocalStorageData(CommonConstants.OTP_TIMER);
        this._helper.removeLocalStorageData(CommonConstants.OTP_SENT);
        sessionStorage.removeItem(CommonConstants.FORGOT_EMAIL);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Create the form
        this.emailFromSession = this._helper.getSessionData(CommonConstants.FORGOT_EMAIL);
        const urlTree = this._router.parseUrl(this._router.url);
        const queryString = urlTree.queryParams;
        const keys = Object.keys(queryString);

        if (keys.length > 0) {
            this.emailFromUrl = keys[0];
            this.isSetPassword = true;
        }
        if (this.emailFromUrl) {
            // this.email = this._helper.decryptResponse(emailFromUrl) ? this._helper.decryptResponse(emailFromUrl) : '';
            this.token = this.emailFromUrl;
            // this.resendOTP();
        } else if(this.emailFromSession) {
            this.isSetPassword = false;
            this.email = this.emailFromSession
        } else {
            if(this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1){
                environment.production ? this._router.navigate(['/']) : this._router.navigate(['/']);
            } else{
                this._router.navigate(['/']);
            }
        }
        var seconds: any = this._helper.getLocalStorageData(
            CommonConstants.OTP_TIMER
        );
        var otpSent: any = this._helper.getLocalStorageData(
            CommonConstants.OTP_SENT
        );
        if (seconds && otpSent) {
            this.hideResendBtn = true;
            this.startTimer();
        } else if (!seconds && otpSent) {
            this.hideResendBtn = false;
        } else {
            this.hideResendBtn = true;
            this.startTimer();
        }
        this.resetPasswordForm = this._formBuilder.group(
  {
    otp: [
      '',
      !this.emailFromUrl ? [Validators.required, Validators.pattern(/^[0-9]{4}$/)] : [],
    ],
    password: ['', [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_]).+$')]],
    passwordConfirm: ['', Validators.required],
  },
  {
    validators: FuseValidators.mustMatch('password', 'passwordConfirm'),
  }
);

    }

    /**
     * Summary: For start otp timer
     */
    startTimer() {
        this.isSendOtp = false;
        this.start();
        this.hideResendBtn = true;
    }

    start() {
        this.displayTimer = true;
        this.resendOtp = false;
        this.seconds = 60;
        let timerControl = 1000;

        this.countDown = timer(0, timerControl)
            .pipe(take(this.seconds))
            .subscribe(() => {
                var seconds: any = this._helper.getLocalStorageData(
                    CommonConstants.OTP_TIMER
                );
                if (seconds) {
                    this.seconds = seconds;
                }
                --this.seconds;
                if (this.seconds == 0) {
                    this.countDown.unsubscribe();
                    this.hideResendBtn = false;
                }
                if (this.hideResendBtn) {
                    this._helper.setLocalStorageData(
                        CommonConstants.OTP_TIMER,
                        this.seconds
                    );
                    this._helper.setLocalStorageData(
                        CommonConstants.OTP_SENT,
                        true
                    );
                } else {
                    this._helper.removeLocalStorageData(
                        CommonConstants.OTP_TIMER
                    );
                }
            });
    }

    /**
     * Summary : This method is use for resent otp
     */
    resendOTP() {
        this.isSendOtp = true;
        let reqData = {
            email: this.email,
        };
        this._authService.resendOTP(reqData, this.isPartner).subscribe((res: any) => {
            if (res?.meta?.status === 1) {
                this._helper.removeLocalStorageData(CommonConstants.OTP_TIMER);
                this.startTimer();
            } else {
                this.isSendOtp = false;
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Reset password
     */
    resetPassword(): void {
        // Return if the form is invalid
        if (this.resetPasswordForm.invalid) {
            return;
        }

        // Disable the form
        this.resetPasswordForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Send the request to the server
        let reqData: any = {};
        if(this.isPartner && this.emailFromUrl){
            reqData = {
                token: this.token,
                partnerPassword: this.resetPasswordForm.get('password').value,
                // otp: this.resetPasswordForm.get('otp').value,
            };
        } else if(this.isPartner && this.emailFromSession) {
                reqData = {
                partnerEmail: this.email,
                partnerPassword: this.resetPasswordForm.get('password').value,
                otp: this.resetPasswordForm.get('otp').value,
            };
        } else {
            reqData = {
                email: this.email,
                password: this.resetPasswordForm.get('password').value,
                otp: this.resetPasswordForm.get('otp').value,
            };
        }
        this._authService
            .resetPassword(reqData, this.isPartner, this.emailFromUrl)
            // .pipe(
            //     finalize(() => {
            //         // Re-enable the form
            //         this.resetPasswordForm.enable();
            //
            //         // Reset the form
            //         this.resetPasswordNgForm.resetForm();
            //
            //         // Show the alert
            //         this.showAlert = true;
            //     })
            // )
            .subscribe(
                (response) => {
                    if (response?.meta?.status === 1) {
                        this.resetPasswordForm.enable();
                        this.resetPasswordNgForm.resetForm();
                        if(this.isPartner){
                            this._router.navigate([environment.production ? '/' : '/partner']);
                        } else {
                            this._router.navigate(['/']);
                        }
                        this._helper.toast(response?.meta?.message, 'success');
                    } else {
                        this.resetPasswordForm.enable();
                        this._helper.toast(response?.meta?.message, 'error');
                    }
                },
                (response) => {
                    this.resetPasswordForm.enable();
                    this._helper.toast(response?.meta?.message, 'error');
                }
            );
    }

    /**
     * Summary: Get time
     * @param value
     */
    transform(value: number): string {
        const minutes: number = Math.floor(value / 60);
        return (
            ('00' + minutes).slice(-2) +
            ':' +
            ('00' + Math.floor(value - minutes * 60)).slice(-2)
        );
    }

    /**
     * Summary: For check input is number or not
     * @param event
     * @param otpInput
     */
    checkNumber(event: ClipboardEvent, otpInput: HTMLInputElement): void {
        const pastedData = event.clipboardData?.getData('text') || '';
        const currentValue = otpInput.value;
        const isOnlyDigits = /^\d+$/.test(pastedData);
        if (currentValue.length == 6 || !isOnlyDigits) {
            event.preventDefault();
            return;
        }
        const newValue = currentValue + pastedData;
        if (newValue.length > 6) {
            event.preventDefault();
        }
    }

    protected readonly LABELS = LABELS;
    protected readonly MatListItemAvatar = MatListItemAvatar;
}
